import { useCallback } from 'react';

import { useCheckoutProvider } from '#components/organisms/checkout/checkout-provider/useCheckoutProvider.js';
import { type ConsumerCheckoutCartsResponse, useShowConsumerCheckout } from '@givebacks/api/store';
import { CheckoutCardProvider } from 'core/Components';

const CheckoutCardSelection = () => {
  const { checkoutId, checkoutOrderSectionConfig } = useCheckoutProvider();
  const { withSaveCardCheckbox, withCardOnFileEnabled } =
    checkoutOrderSectionConfig?.cardSelectionConfig ?? {};
  const { data: isPaymentMethodNeeded } = useShowConsumerCheckout({
    checkoutId,
    select: useCallback(
      (data: ConsumerCheckoutCartsResponse) => data.checkout.payment_method_needed,
      []
    ),
  });

  if (!isPaymentMethodNeeded) return null;

  return (
    <CheckoutCardProvider
      withSaveCardCheckbox={withSaveCardCheckbox}
      withCardOnFileEnabled={withCardOnFileEnabled}
    />
  );
};

export { CheckoutCardSelection };
